import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Card, Row, Col, Typography, Statistic, Space, Alert } from 'antd';
import { UserOutlined, SettingOutlined, DollarCircleOutlined, TeamOutlined } from '@ant-design/icons';
import { useApp } from '../context/AppContext';

const { Content, Header } = Layout;
const { Title, Text } = Typography;

const AdminPage = () => {
  const navigate = useNavigate();
  const { user } = useApp();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Проверяем права администратора
    if (!user) {
      navigate('/');
      return;
    }

    if (!user.is_admin) {
      navigate('/');
      return;
    }

    setLoading(false);
  }, [user, navigate]);

  useEffect(() => {
    // Настройка BackButton для возврата на главную страницу
    if (window.Telegram?.WebApp?.BackButton) {
      const backButton = window.Telegram.WebApp.BackButton;
      
      const handleBackClick = () => {
        navigate('/');
      };

      // Показываем кнопку назад
      backButton.show();
      backButton.onClick(handleBackClick);

      // Cleanup при размонтировании
      return () => {
        backButton.offClick(handleBackClick);
        backButton.hide();
      };
    }
  }, [navigate]);

  if (loading) {
    return null;
  }

  const adminSections = [
    {
      title: 'Управление пользователями',
      description: 'Просмотр и управление всеми пользователями системы',
      icon: <UserOutlined style={{ fontSize: '28px', color: '#1677ff' }} />,
      path: '/admin/users'
    },
    {
      title: 'Управление тарифами',
      description: 'Настройка цен для серверов',
      icon: <DollarCircleOutlined style={{ fontSize: '28px', color: '#faad14' }} />,
      path: '/admin/pricing',
    },
    {
      title: 'Партнёрская программа',
      description: 'Настройка процентов и заявки на вывод',
      icon: <TeamOutlined style={{ fontSize: '28px', color: '#52c41a' }} />,
      path: '/admin/referral',
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ 
        background: 'transparent', 
        padding: '0 16px',
        borderBottom: '1px solid var(--ant-color-border)'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center',
          height: '100%'
        }}>
          <Title level={4} style={{ margin: 0 }}>
            Админ-панель
          </Title>
        </div>
      </Header>

      <Content style={{ padding: '16px' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          {/* Приветствие */}
          <Card bodyStyle={{ padding: '16px' }}>
            <Space direction="vertical" size="small">
              <Title level={5} style={{ margin: 0 }}>
                Добро пожаловать, {user?.first_name || 'Администратор'}!
              </Title>
              <Text type="secondary" style={{ fontSize: '14px' }}>
                Управление пользователями, подписками и тарифами системы.
              </Text>
            </Space>
          </Card>

          {/* Основные разделы */}
          <Row gutter={[12, 12]}>
            {adminSections.map((section, index) => (
              <Col xs={24} sm={12} md={8} key={index}>
                <Card
                  hoverable={!section.disabled}
                  style={{ 
                    height: '160px',
                    opacity: section.disabled ? 0.6 : 1,
                    cursor: section.disabled ? 'not-allowed' : 'pointer'
                  }}
                  bodyStyle={{ 
                    padding: '16px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                  }}
                  onClick={() => {
                    if (!section.disabled) {
                      navigate(section.path);
                    }
                  }}
                >
                  <Space direction="vertical" size="medium" style={{ 
                    width: '100%',
                    textAlign: 'center'
                  }}>
                    <div>{section.icon}</div>
                    <div>
                      <Title level={5} style={{ 
                        margin: '0 0 4px 0',
                        color: section.disabled ? undefined : section.color,
                        fontSize: '14px'
                      }}>
                        {section.title}
                      </Title>
                      <Text type="secondary" style={{ fontSize: '12px' }}>
                        {section.description}
                      </Text>
                    </div>
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>

          {/* Быстрая статистика */}
          <Card 
            title={<Text style={{ fontSize: '16px' }}>Быстрая статистика</Text>}
            bodyStyle={{ padding: '16px' }}
          >
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={6}>
                <Statistic 
                  title="Всего пользователей" 
                  value="—"
                  valueStyle={{ fontSize: '18px' }}
                />
              </Col>
              <Col xs={12} sm={6}>
                <Statistic 
                  title="Активных подписок" 
                  value="—"
                  valueStyle={{ fontSize: '18px' }}
                />
              </Col>
              <Col xs={12} sm={6}>
                <Statistic 
                  title="Серверов" 
                  value="—"
                  valueStyle={{ fontSize: '18px' }}
                />
              </Col>
              <Col xs={12} sm={6}>
                <Statistic 
                  title="Администраторов" 
                  value="—"
                  valueStyle={{ fontSize: '18px' }}
                />
              </Col>
            </Row>
          </Card>
        </Space>
      </Content>
    </Layout>
  );
};

export default AdminPage; 